/* =====================================================================
   DIVISÃO DO CARRINHO — frete grátis da coleção Especialista.

   O QUE ESTE ARQUIVO FAZ
   Quando o carrinho tem itens da coleção participante somando o mínimo E
   também itens de outras coleções, o frete grátis nativo some (a Shopify
   descarta tarifas que existem em um perfil só). Aqui oferecemos ao cliente
   finalizar os itens participantes sozinhos, numa compra separada, onde a
   tarifa gratuita nativa já aparece.

   O QUE ESTE ARQUIVO **NÃO** FAZ
   - Não calcula, não cria, não zera e não substitui tarifa de frete.
   - Não finaliza, não paga e não confirma pedido nenhum.
   - Não remove a tarifa nativa, não mexe em perfil de entrega, cupom ou no
     Worker. A segunda compra só começa por ação explícita do cliente.

   POR QUE ISOLAR EXIGE RECUPERAÇÃO
   O carrinho do Shopify é um só por sessão, e abas compartilham o mesmo
   carrinho. Isolar, portanto, SEMPRE mexe no carrinho do cliente. Guardar e
   devolver os itens é responsabilidade nossa — é o que a máquina de estados
   abaixo faz, com mescla aditiva (nunca `clear`), trava entre abas e prazo
   de validade.

   Referência de estilo e de fluxo: sections/main-product.liquid (simulador de
   frete) e assets/cart-drawer.js (carrinho).
   ===================================================================== */
(function () {
  "use strict";

  var STORE_KEY = "zr-split-v1";
  var LOCK_KEY = "zr-split-lock-v1";
  var ZIP_KEY = "mf-cart-shipping-zip";
  var DISCOUNT_KEY = "mf-cart-discount-code";

  var MAX_IDADE_MS = 24 * 60 * 60 * 1000;
  var LOCK_TTL_MS = 15000;
  var TENTATIVAS = 3;
  var DELAYS = [200, 600, 1200];

  var DONO = Math.random().toString(36).slice(2) + Date.now().toString(36);

  /* ------------------------------------------------------------------
     Leitura de configuração e de dados. Nada é presumido: sem os dados do
     servidor, o recurso simplesmente não liga.
     ------------------------------------------------------------------ */
  function lerJson(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.error("[zr-split] Nao foi possivel ler #" + id + ".", e);
      return null;
    }
  }

  var cfg = lerJson("ZrSplitDados");
  var frete = lerJson("ZrFreteGratisDados");

  if (!cfg || !cfg.ativo) return;
  if (!frete || !frete.ativo) return;

  var IDS = new Set((frete.produtos || []).map(Number));
  var MINIMO = Number(frete.minimo || 0);
  var ESPERADO = Number(frete.esperado || 0);
  var COMPLETO = !(ESPERADO > IDS.size);
  if (!IDS.size || MINIMO <= 0) return;

  /* ZR FRETE 58 (2026-10-10): completa a lista via products.json (publico,
     same-origin) quando o Liquid truncou. Sem isto, poliamidas ativadas
     (IDs alem do teto) seriam tratadas como "outras colecoes" e quebrariam
     o split. Ate completar, o bloco fica oculto (fail-closed em render). */
  function completarIds() {
    if (COMPLETO || !frete.colecaoUrl) return;
    fetch(String(frete.colecaoUrl).replace(/\/$/, "") + "/products.json?limit=250", {
      headers: { Accept: "application/json" }
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || !Array.isArray(j.products) || !j.products.length) return;
        j.products.forEach(function (p) {
          if (p && p.id) IDS.add(Number(p.id));
        });
        COMPLETO = !(ESPERADO > IDS.size);
        avaliar();
      })
      .catch(function () {});
  }

  /* ------------------------------------------------------------------
     Armazenamento. Se não houver persistência confiável, o recurso NÃO
     liga: sem isso, o carrinho do cliente seria esvaziado sem caminho de
     volta. Falhar fechado é obrigatório aqui.
     ------------------------------------------------------------------ */
  var storageOk = (function () {
    try {
      var k = "__zr_split_sonda__";
      localStorage.setItem(k, "1");
      var v = localStorage.getItem(k);
      localStorage.removeItem(k);
      return v === "1";
    } catch (e) {
      return false;
    }
  })();

  if (!storageOk) {
    console.warn(
      "[zr-split] Armazenamento indisponivel. O recurso fica desligado para nao " +
        "arriscar o carrinho do cliente."
    );
    return;
  }

  var store = {
    ler: function (chave) {
      try {
        var raw = localStorage.getItem(chave);
        return raw ? JSON.parse(raw) : null;
      } catch (e) {
        return null;
      }
    },
    gravar: function (chave, valor) {
      try {
        localStorage.setItem(chave, JSON.stringify(valor));
        return true;
      } catch (e) {
        return false;
      }
    },
    apagar: function (chave) {
      try {
        localStorage.removeItem(chave);
      } catch (e) {}
    }
  };

  /* ------------------------------------------------------------------
     Utilitários.
     ------------------------------------------------------------------ */
  function formatMoney(centavos) {
    return (Number(centavos || 0) / 100).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL"
    });
  }

  function escapeHtml(valor) {
    return String(valor === null || valor === undefined ? "" : valor)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function normalizarCep(valor) {
    var d = String(valor || "").replace(/\D/g, "").slice(0, 8);
    return d.length > 5 ? d.slice(0, 5) + "-" + d.slice(5) : d;
  }

  /*
     Chave de identidade de uma linha do carrinho: variante + properties.
     É o que diferencia duas linhas da MESMA variante com gravações
     diferentes. Duas linhas equivalentes caem na mesma chave, e as
     quantidades somam — é assim que comparamos e mesclamos.
  */
  function chaveLinha(variantId, properties) {
    var props = properties && typeof properties === "object" ? properties : {};
    var partes = Object.keys(props)
      .sort()
      .map(function (k) {
        return k + "=" + String(props[k]);
      });
    return String(variantId) + "|" + partes.join("&");
  }

  /* Multiconjunto de linhas: chave -> quantidade. Ordem não importa. */
  function multiconjunto(itens) {
    var mapa = {};
    (itens || []).forEach(function (it) {
      var k = chaveLinha(it.variant_id !== undefined ? it.variant_id : it.id, it.properties);
      mapa[k] = (mapa[k] || 0) + Number(it.quantity || 0);
    });
    return mapa;
  }

  function mesmoMulticonjunto(a, b) {
    var ka = Object.keys(a);
    var kb = Object.keys(b);
    if (ka.length !== kb.length) return false;
    for (var i = 0; i < ka.length; i += 1) {
      if (a[ka[i]] !== b[ka[i]]) return false;
    }
    return true;
  }

  /* ------------------------------------------------------------------
     Carrinho.
     ------------------------------------------------------------------ */
  function lerCarrinho() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) {
      if (!r.ok) throw new Error("Nao foi possivel carregar o carrinho.");
      return r.json();
    });
  }

  function postJson(url, corpo) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(corpo)
    }).then(function (r) {
      return r.json().catch(function () {
        return {};
      });
    });
  }

  function ehParticipante(item) {
    return IDS.has(Number(item.product_id));
  }

  function elegivelCentavos(itens) {
    return (itens || []).reduce(function (soma, it) {
      return ehParticipante(it) ? soma + Number(it.final_line_price || 0) : soma;
    }, 0);
  }

  function participantesDe(itens) {
    return (itens || []).filter(ehParticipante);
  }

  function naoParticipantesDe(itens) {
    return (itens || []).filter(function (it) {
      return !ehParticipante(it);
    });
  }

  function getCep() {
    try {
      return normalizarCep(localStorage.getItem(ZIP_KEY) || "");
    } catch (e) {
      return "";
    }
  }

  /* CUPOM OCULTO (2026-10-09): campo desativado — nunca lê nem aplica desconto. */
  function getCupom() {
    try {
      localStorage.removeItem(DISCOUNT_KEY);
    } catch (e) {}
    return "";
  }

  /* ------------------------------------------------------------------
     Trava entre abas. As abas compartilham o carrinho; duas recuperações
     simultâneas duplicariam quantidades. Quem não obtém a trava, desiste.
     ------------------------------------------------------------------ */
  function pegarTrava() {
    var agora = Date.now();
    var atual = store.ler(LOCK_KEY);
    if (atual && atual.dono !== DONO && agora - Number(atual.ts || 0) < LOCK_TTL_MS) {
      return false;
    }
    store.gravar(LOCK_KEY, { dono: DONO, ts: agora });
    var confirmado = store.ler(LOCK_KEY);
    return !!(confirmado && confirmado.dono === DONO);
  }

  function soltarTrava() {
    var atual = store.ler(LOCK_KEY);
    if (atual && atual.dono === DONO) store.apagar(LOCK_KEY);
  }

  /* ------------------------------------------------------------------
     Mescla aditiva — NUNCA `clear`.
     Adiciona só o que falta, pelo delta, casando por variante+properties.
     - Não sobrescreve quantidade que o cliente aumentou.
     - Não destrói item que o cliente adicionou em outra aba.
     - Não duplica, porque o /cart/add.js soma.
     ------------------------------------------------------------------ */
  function mesclar(linhasAlvo) {
    return lerCarrinho().then(function (cart) {
      var atual = multiconjunto(cart.items);
      var porChave = {};
      (linhasAlvo || []).forEach(function (it) {
        var k = chaveLinha(it.variant_id, it.properties);
        if (!porChave[k]) {
          porChave[k] = { id: Number(it.variant_id), properties: it.properties || {}, quantidade: 0 };
        }
        porChave[k].quantidade += Number(it.quantity || 0);
      });

      var faltando = [];
      Object.keys(porChave).forEach(function (k) {
        var alvo = porChave[k];
        var delta = alvo.quantidade - Number(atual[k] || 0);
        if (delta > 0) {
          var item = { id: alvo.id, quantity: delta };
          if (Object.keys(alvo.properties).length) item.properties = alvo.properties;
          faltando.push(item);
        }
      });

      if (!faltando.length) return true;
      return postJson("/cart/add.js", { items: faltando }).then(function (res) {
        /* /cart/add.js devolve 422 com `description` quando algo falha. */
        if (res && res.status) throw new Error(res.description || "Falha ao repor itens.");
        return true;
      });
    });
  }

  /* Repõe com verificação multiconjunto e repetição espaçada. */
  function mesclarComVerificacao(linhasAlvo, tentativas) {
    var restantes = typeof tentativas === "number" ? tentativas : TENTATIVAS;

    function tentar(left) {
      return mesclar(linhasAlvo)
        .then(function () {
          return lerCarrinho();
        })
        .then(function (cart) {
          var atual = multiconjunto(cart.items);
          var alvo = multiconjunto(linhasAlvo);
          var faltou = Object.keys(alvo).some(function (k) {
            return Number(atual[k] || 0) < alvo[k];
          });
          if (!faltou) return true;
          if (left > 1) {
            return new Promise(function (resolve) {
              window.setTimeout(function () {
                resolve(tentar(left - 1));
              }, DELAYS[TENTATIVAS - left] || 1200);
            });
          }
          return false;
        })
        .catch(function () {
          if (left > 1) {
            return new Promise(function (resolve) {
              window.setTimeout(function () {
                resolve(tentar(left - 1));
              }, DELAYS[TENTATIVAS - left] || 1200);
            });
          }
          return false;
        });
    }

    return tentar(restantes);
  }

  /* ------------------------------------------------------------------
     Cotação — mesmas chamadas nativas do tema, em série.
     Serve para CONFIRMAR que a tarifa de R$ 0,00 existe antes de mandar o
     cliente ao checkout. Nunca prometemos frete por aritmética.
     ------------------------------------------------------------------ */
  function ufDoCep(cepDigitos) {
    return fetch("https://viacep.com.br/ws/" + cepDigitos + "/json/")
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (d) {
        return d && !d.erro && d.uf ? d.uf : null;
      })
      .catch(function () {
        return null;
      });
  }

  function pollTarifas(cepDigitos) {
    var url =
      "/cart/async_shipping_rates.json?shipping_address%5Bzip%5D=" +
      cepDigitos +
      "&shipping_address%5Bcountry%5D=Brazil";

    function tentar(restantes) {
      return fetch(url, { headers: { Accept: "application/json" } })
        .then(function (r) {
          return r.text();
        })
        .then(function (txt) {
          /* A loja responde HTML (anti-bot / 429) sob sondagem agressiva. */
          if (!txt || txt.charAt(0) === "<") return null;
          try {
            var j = JSON.parse(txt);
            return j && Array.isArray(j.shipping_rates) && j.shipping_rates.length
              ? j.shipping_rates
              : null;
          } catch (e) {
            return null;
          }
        })
        .catch(function () {
          return null;
        })
        .then(function (rates) {
          if (rates) return rates;
          if (restantes <= 1) return [];
          return new Promise(function (resolve) {
            window.setTimeout(function () {
              resolve(tentar(restantes - 1));
            }, 1200);
          });
        });
    }

    return tentar(20);
  }

  function cotar(cepDigitos) {
    return ufDoCep(cepDigitos).then(function (uf) {
      var corpo = new URLSearchParams();
      corpo.set("shipping_address[zip]", cepDigitos);
      corpo.set("shipping_address[country]", "Brazil");
      if (uf) corpo.set("shipping_address[province]", uf);

      return fetch("/cart/prepare_shipping_rates.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
          Accept: "application/json"
        },
        body: corpo.toString()
      })
        .then(function () {
          return pollTarifas(cepDigitos);
        })
        .catch(function () {
          return [];
        });
    });
  }

  function temTarifaGratis(rates) {
    /* Por PREÇO, não por nome: o nome da tarifa é configurável no admin e
       pode mudar sem aviso. O que importa é existir uma opção de R$ 0,00. */
    return (rates || []).some(function (r) {
      return Number(r.price) === 0;
    });
  }

  /* ------------------------------------------------------------------
     Interface do bloco.
     ------------------------------------------------------------------ */
  var blocos = function () {
    return Array.prototype.slice.call(document.querySelectorAll("[data-zr-split]"));
  };

  function avisarBloco(bloco, msg) {
    var el = bloco.querySelector("[data-zr-split-aviso]");
    if (!el) return;
    var texto = String(msg || "").trim();
    el.textContent = texto;
    el.hidden = !texto;
  }

  function ocuparBloco(bloco, ocupado) {
    var veu = bloco.querySelector("[data-zr-split-veu]");
    var botao = bloco.querySelector("[data-zr-split-botao]");
    if (veu) {
      veu.hidden = !ocupado;
      veu.textContent = ocupado ? cfg.msgPreparando : "";
    }
    if (botao) botao.disabled = !!ocupado;
  }

  function render(cart) {
    var itens = (cart && cart.items) || [];
    var participantes = participantesDe(itens);
    var naoParticipantes = naoParticipantesDe(itens);
    var elegivel = elegivelCentavos(itens);
    var pendencia = store.ler(STORE_KEY);

    /* Três condições, todas obrigatórias. Sem qualquer uma, o bloco não
       aparece — não se anuncia benefício inexistente nem fluxo sem sentido.
       ZR FRETE 58: sem lista completa, fica oculto (fail-closed). */
    var mostrar = COMPLETO && naoParticipantes.length > 0 && elegivel >= MINIMO && !pendencia;

    blocos().forEach(function (bloco) {
      bloco.hidden = !mostrar;
      if (!mostrar) {
        avisarBloco(bloco, "");
        ocuparBloco(bloco, false);
        return;
      }

      var alvo = bloco.querySelector("[data-zr-split-valor]");
      if (alvo) {
        var tpl = bloco.getAttribute("data-zr-split-valor-tpl") || cfg.valorTpl || "{valor}";
        alvo.textContent = String(tpl).replace("{valor}", formatMoney(elegivel));
      }

      /* Se existe penDÊNCIA ativa (recuperação pendente) além do elegível,
         descrever o valor de forma honesta: ele diz respeito aos produtos
         Especialista que voltarão, não a uma divisão nova agora. */
      var temPendencia = !!store.ler(STORE_KEY);
      if (temPendencia && bloco.dataset) {
        try { bloco.dataset.splitPendente = "1"; } catch (e) {}
      } else if (bloco.dataset) {
        try { delete bloco.dataset.splitPendente; } catch (e) {}
      }
    });
  }

  /* ------------------------------------------------------------------
     Banner de recuperação — criado no <body>, fora do drawer, porque
     precisa aparecer em qualquer página, com o drawer fechado.
     ------------------------------------------------------------------ */
  var bannerEl = null;

  function fecharBanner() {
    if (bannerEl && bannerEl.parentNode) bannerEl.parentNode.removeChild(bannerEl);
    bannerEl = null;
  }

  function mostrarBanner(msg, acoes) {
    fecharBanner();

    bannerEl = document.createElement("div");
    bannerEl.className = "zr-split-banner";
    bannerEl.setAttribute("role", "status");

    var texto = document.createElement("p");
    texto.className = "zr-split-banner__texto";
    texto.textContent = msg;
    bannerEl.appendChild(texto);

    var linha = document.createElement("div");
    linha.className = "zr-split-banner__acoes";

    (acoes || []).forEach(function (acao) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "zr-split-banner__botao" + (acao.secundario ? " is-secundario" : "");
      b.textContent = acao.rotulo;
      b.addEventListener("click", function () {
        acao.aoClicar();
      });
      linha.appendChild(b);
    });

    bannerEl.appendChild(linha);
    document.body.appendChild(bannerEl);
  }

  /* ------------------------------------------------------------------
     Resolução de pendência — decisão em TRÊS vias, nunca duas.
     ------------------------------------------------------------------ */
  var resolvendo = false;

  function resolverPendencia(cart) {
    if (resolvendo) return Promise.resolve();
    var rec = store.ler(STORE_KEY);
    if (!rec || !rec.itens || !rec.itens.length) return Promise.resolve();

    /* Prazo: um registro antigo não pode ressuscitar itens abandonados num
       carrinho que o cliente encheu depois. */
    var idade = Date.now() - Number(rec.criadoEm || 0);
    if (idade > MAX_IDADE_MS) {
      var itens = (cart && cart.items) || [];
      if (!itens.length) {
        var soOsOutros = rec.itens.filter(function (it) {
          return rec.participantes.indexOf(chaveLinha(it.variant_id, it.properties)) === -1;
        });
        oferecerRecuperacao(soOsOutros, cfg.msgSegunda);
      }
      return Promise.resolve();
    }

    resolvendo = true;

    var itens = (cart && cart.items) || [];
    var atual = multiconjunto(itens);
    var snapCompleto = multiconjunto(rec.itens);
    var snapParticipantes = multiconjunto(
      rec.itens.filter(function (it) {
        return rec.participantes.indexOf(chaveLinha(it.variant_id, it.properties)) !== -1;
      })
    );
    var somenteOsOutros = rec.itens.filter(function (it) {
      return rec.participantes.indexOf(chaveLinha(it.variant_id, it.properties)) === -1;
    });

    /* Caso 1 — carrinho vazio: o pedido foi criado e consumiu o carrinho.
       Devolvemos só os itens das outras coleções (a "segunda compra"). */
    if (!itens.length) {
      if (!somenteOsOutros.length) {
        store.apagar(STORE_KEY);
        resolvendo = false;
        return Promise.resolve();
      }
      return executarRecuperacao(somenteOsOutros, cfg.msgSegunda).then(function () {
        resolvendo = false;
      });
    }

    /* Caso 2 — o carrinho está exatamente como deixamos (só participantes):
       o cliente desistiu no checkout. Devolvemos o carrinho inteiro. */
    if (mesmoMulticonjunto(atual, snapParticipantes)) {
      return executarRecuperacao(rec.itens, cfg.msgDesfazer).then(function () {
        resolvendo = false;
      });
    }

    /* Caso 3 — o carrinho já é o completo: nada a fazer. */
    if (mesmoMulticonjunto(atual, snapCompleto)) {
      store.apagar(STORE_KEY);
      resolvendo = false;
      return Promise.resolve();
    }

    /* Caso 4 — ambíguo (o cliente mexeu no carrinho em outro lugar).
       NÃO mexemos automaticamente. Oferecemos as duas saídas. */
    oferecerRecuperacao(rec.itens, cfg.msgAmbiguo);
    resolvendo = false;
    return Promise.resolve();
  }

  function executarRecuperacao(linhas, mensagem) {
    if (!pegarTrava()) return Promise.resolve(false);
    return mesclarComVerificacao(linhas)
      .then(function (ok) {
        if (ok) {
          store.apagar(STORE_KEY);
          mostrarBanner(mensagem, [
            { rotulo: "OK", aoClicar: fecharBanner }
          ]);
          anunciarAtualizacao();
        } else {
          /* Não conseguimos repor (variante esgotada, por exemplo).
             Mantemos o registro e paramos de insistir sozinhos. */
          mostrarBanner(
            "Não conseguimos repor todos os itens agora. Eles continuam guardados.",
            [
              {
                rotulo: cfg.btnDesfazer,
                aoClicar: function () {
                  executarRecuperacao(linhas, mensagem);
                }
              },
              { rotulo: cfg.btnManter, secundario: true, aoClicar: fecharBanner }
            ]
          );
        }
        soltarTrava();
        return ok;
      })
      .catch(function () {
        soltarTrava();
        return false;
      });
  }

  function oferecerRecuperacao(linhas, mensagem) {
    mostrarBanner(mensagem, [
      {
        rotulo: cfg.btnDesfazer,
        aoClicar: function () {
          executarRecuperacao(linhas, cfg.msgDesfazer);
        }
      },
      { rotulo: cfg.btnManter, secundario: true, aoClicar: fecharBanner }
    ]);
  }

  function anunciarAtualizacao() {
    /* ADIADO de propósito: quem chama está no meio de uma avaliação (guard
       `avaliando`), e um evento síncrono seria ignorado — o carrinho voltaria
       a ser desenhado com o estado VELHO e o bloco sumiria logo após a
       recuperação. Adiado, reavalia com o carrinho já restaurado. */
    window.setTimeout(function () {
      try {
        document.dispatchEvent(new CustomEvent("zafer:cart-updated"));
        document.dispatchEvent(new CustomEvent("cart:refresh", { detail: {} }));
      } catch (e) {}
    }, 0);
  }

  /* ------------------------------------------------------------------
     Ação principal: guardar, isolar, CONFIRMAR e só então ir ao checkout.
     ------------------------------------------------------------------ */
  function comprarEspecialista(botao) {
    var bloco = botao.closest("[data-zr-split]");
    if (!bloco) return;

    avisarBloco(bloco, "");

    var cep = getCep();
    var cepDigitos = cep.replace(/\D/g, "");

    if (cepDigitos.length !== 8) {
      /* Sem CEP não há como CONFIRMAR a tarifa gratuita. Nunca inventamos
         um CEP nem mandamos o cliente a um checkout às cegas. */
      avisarBloco(bloco, cfg.msgSemCep);
      var campoCep = document.querySelector("[data-cart-shipping-zip]");
      if (campoCep) {
        try {
          campoCep.focus();
        } catch (e) {}
      }
      return;
    }

    if (!pegarTrava()) return;

    ocuparBloco(bloco, true);

    lerCarrinho()
      .then(function (cart) {
        var itens = (cart && cart.items) || [];
        var participantes = participantesDe(itens);
        var naoParticipantes = naoParticipantesDe(itens);
        var elegivel = elegivelCentavos(itens);

        /* Reconfere no carrinho REAL: a tela pode estar desatualizada. */
        if (!naoParticipantes.length || elegivel < MINIMO) {
          throw new Error("estado-mudou");
        }

        var registro = {
          v: 1,
          fase: "armado",
          criadoEm: Date.now(),
          dono: DONO,
          cep: cep,
          cupom: getCupom(),
          elegivelCentavos: elegivel,
          itens: itens.map(function (it) {
            return {
              variant_id: Number(it.variant_id),
              quantity: Number(it.quantity || 0),
              key: it.key || "",
              properties: it.properties && Object.keys(it.properties).length ? it.properties : undefined
            };
          }),
          participantes: participantes.map(function (it) {
            return chaveLinha(it.variant_id, it.properties);
          }),
          nonParticipantes: naoParticipantes.map(function (it) {
            return {
              variant_id: Number(it.variant_id),
              quantity: Number(it.quantity || 0),
              properties: it.properties && Object.keys(it.properties).length ? it.properties : undefined
            };
          })
        };

        if (!store.gravar(STORE_KEY, registro)) {
          throw new Error("sem-armazenamento");
        }

        /* Uma única requisição, por `key`. Por índice, cada remoção
           deslocaria os índices das seguintes. As linhas participantes
           NÃO são tocadas — variante, quantidade e properties sobrevivem. */
        var updates = {};
        naoParticipantes.forEach(function (it) {
          updates[it.key] = 0;
        });

        return postJson("/cart/update.js", { updates: updates })
          .then(function () {
            return lerCarrinho();
          })
          .then(function (depois) {
            var sobrou = (depois && depois.items) || [];
            var aindaTemOutros = naoParticipantesDe(sobrou).length > 0;
            var eleg = elegivelCentavos(sobrou);

            /* /cart/update.js responde 200 mesmo com chave inexistente: a
               falha é silenciosa. Por isso conferimos o carrinho de fato. */
            if (aindaTemOutros || eleg < MINIMO) {
              throw new Error("isolamento-falhou");
            }

            return cotar(cepDigitos).then(function (rates) {
              if (!temTarifaGratis(rates)) throw new Error("sem-tarifa-gratis");
              return sobrou;
            });
          });
      })
      .then(function () {
        /* Só chegamos aqui com a tarifa de R$ 0,00 CONFIRMADA no carrinho
           isolado, para o CEP do cliente. */
        var rec = store.ler(STORE_KEY);
        if (rec) {
          rec.fase = "no_checkout";
          store.gravar(STORE_KEY, rec);
        }
        soltarTrava();

        var base = cfg.checkoutUrl || "/checkout";
        var digitos = getCep().replace(/\D/g, "");
        if (digitos.length === 8) {
          base += (base.indexOf("?") === -1 ? "?" : "&") + "shipping_address[zip]=" + digitos;
        }
        var cupom = getCupom();
        window.location.href = cupom
          ? "/discount/" + encodeURIComponent(cupom) + "?redirect=" + encodeURIComponent(base)
          : base;
      })
      .catch(function (erro) {
        var rec = store.ler(STORE_KEY);
        var mensagem =
          erro && erro.message === "sem-tarifa-gratis"
            ? cfg.msgFalha
            : erro && erro.message === "sem-armazenamento"
            ? "Seu navegador não permitiu guardar o carrinho. A compra separada não foi iniciada."
            : cfg.msgFalha;

        var desfazer = function () {
          ocuparBloco(bloco, false);
          if (!rec || !rec.itens) {
            avisarBloco(bloco, mensagem);
            soltarTrava();
            return;
          }
          mesclarComVerificacao(
            rec.itens.filter(function (it) {
              return rec.participantes.indexOf(chaveLinha(it.variant_id, it.properties)) === -1;
            })
          ).then(function (ok) {
            if (ok) {
              store.apagar(STORE_KEY);
              soltarTrava();
              window.location.reload();
            } else {
              avisarBloco(bloco, mensagem);
              soltarTrava();
            }
          });
        };

        desfazer();
      });
  }

  /* ------------------------------------------------------------------
     Ligações. Delegação única no documento: cobre as duas cópias do bloco
     (drawer e página do carrinho) com um só listener.
     ------------------------------------------------------------------ */
  document.addEventListener("click", function (event) {
    var botao = event.target.closest("[data-zr-split-botao]");
    if (!botao) return;
    event.preventDefault();
    comprarEspecialista(botao);
  });

  var avaliando = false;

  function avaliar() {
    if (avaliando) return;
    avaliando = true;
    lerCarrinho()
      .then(function (cart) {
        return resolverPendencia(cart).then(function () {
          render(cart);
        });
      })
      .catch(function (erro) {
        console.error("[zr-split]", erro);
      })
      .then(function () {
        avaliando = false;
      });
  }

  function iniciar() {
    completarIds();
    avaliar();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", iniciar);
  } else {
    iniciar();
  }

  /* O botão voltar costuma restaurar do cache sem re-disparar
     DOMContentLoaded. Sem estas reavaliações, o fluxo silenciosamente
     não rodaria ao retornar do checkout. */
  window.addEventListener("pageshow", function (event) {
    if (event.persisted) avaliar();
  });
  window.addEventListener("focus", avaliar);
  document.addEventListener("visibilitychange", function () {
    if (!document.hidden) avaliar();
  });

  /* Mudanças feitas por outros scripts do tema. */
  document.addEventListener("zafer:cart-updated", avaliar);
})();
